<template>
  <div style="height: 100%">
    <div style="text-align: center; margin: 20px; font-size: 30px">
      出运编码 {{ ship_no }}
    </div>
    <el-row>
      <el-col :span="24" style="text-align: right; margin-bottom: 20px">
        <el-button type="primary" size="middle" @click="editProduct"
          ><el-icon style="vertical-align: middle"> <EditPen /></el-icon>
          <span style="vertical-align: middle">编辑</span></el-button
        >
        <el-button type="primary" size="middle" @click="saveProduct"
          ><el-icon style="vertical-align: middle"> <Check /></el-icon>
          <span style="vertical-align: middle">保存</span></el-button
        >
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <isdTable
          show-summary
          :loading="tableLoading"
          :rows="totalData"
          :height="600"
          :columns="config.columns"
          :selection="config.selection"
          :actions="config.actions"
          @action-click="actionClick"
          style="font-size: 12px"
        >
          <template v-slot:col-append="{ col, row }">
            <div v-if="col.type === 'pdtNum'">
              <span v-if="!isEdit"> {{ row[col.prop] }}</span>
              <el-input v-else v-model="row[col.prop]"></el-input>
            </div>
          </template>
        </isdTable>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <isdPagination
          @size-change="sizeChange"
          :current-page="currentPage"
          @current-change="pageChange"
          layout="total,sizes,prev,pager,next,jumper"
          :page-size="pageSize"
          :page-sizes="[20, 50, 100]"
          :total="pageTotal"
        ></isdPagination>
      </el-col>
    </el-row>
    <!-- 新增/编辑弹窗 -->
    <isdFormDialog
      ref="formDialogIns"
      :config="config.forms"
      :loading="formDialog.loading"
      :label-width="formDialog.labelWidth"
      :row="formDialog.row"
      v-model="formDialog.show"
      :col="formDialog.col"
      :title="formDialog.title"
      :width="formDialog.width"
      @close-dialog="closeFormDialog"
    ></isdFormDialog>
  </div>
</template>
<script>
import { ref, reactive, onMounted } from "vue";
import { EditPen, Check } from "@element-plus/icons-vue";
import { useRoute, useRouter, route } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import {
  getShippingDetailsList,
  addShippingDetails,
  delShippingDetails,
} from "@/network/shipping.js";
import isdFormDialog from "@/views/components/isdFormDialog/Index.vue";
import isdTable from "@/views/components/isdTable/index.vue";
import configData from "./config";
import { ListClass } from "@/composition/ListClass.js";
import isdPagination from "@/views/components/isdPage/index.vue";
import lodash from "lodash";
export default {
  components: {
    EditPen,
    Check,
    isdFormDialog,
    isdTable,
    isdPagination,
  },
  setup(props, context) {
    const isEdit = ref(false);
    const formDialogIns = ref(null);
    const configCopy = reactive(lodash.cloneDeep(configData));
    const config = reactive(lodash.cloneDeep(configData));
    // 新建/修改弹窗对象
    const formDialog = reactive({
      labelWidth: "90px", // 弹窗label宽度
      loading: false, // 表单加载中显示
      row: {}, // 数据项对象
      show: false, // 显示弹窗
      col: 1, // 弹窗内列数
      title: "", // 弹窗标题
      width: "450px", // 弹窗宽度
    });
    const route = ref(useRoute());
    const ship_id = ref(null);
    const ship_no = ref(null);
    //选中的订单ID或者修改更新时，传过来的参数（upt+出运单id）
    const shippingInfo = route.value.query.arrData;
    class TableList extends ListClass {
      beforeGetList(condition) {
        condition.ship_id = ship_id.value; //返回前端后续保存到关系表
        condition.ship_no = ship_no.value; //仅返回前端表格显示用
        condition.shippingInfo = shippingInfo; //把勾选的订单id传过去
        return condition;
      }
    }
    const {
      currentPage,
      pageSize,
      pageTotal,
      tableLoading,
      totalData,
      getList,
      searchList,
      pageChange,
      sizeChange,
      handleSelectedRow,
    } = new TableList({
      Api: {
        listApi: getShippingDetailsList,
      },
    });
    const getShippingDetails = () => {
      getList();
    };
    const editProduct = () => {
      isEdit.value = true;
    };
    // 删除
    const removeProduct = (row, index) => {
      if (!row.id) {
        totalData.value.splice(index, 1);
      } else {
        del(row.id);
      }
    };
    // 保存
    const saveProduct = () => {
      isEdit.value = false;
      addShippingDetails({
        data: totalData.value,
        ship_id: ship_id.value,
      }).then((res) => {
        if (res.code == 0) {
          Object.assign(shippingInfo, res.data); // 获取后台保存后返回的数据
          getList();
          ElMessage.success(res.msg);
        } else if (res.code == 71) {
          ElMessage.error(res.msg);
          getList();
        } else {
          ElMessage.error(res.msg);
          getList();
        }
      });
    };
    // 编辑删除事件
    const actionClick = (event, row, rIndex) => {
      switch (event) {
        case "del":
          removeProduct(row, rIndex);
          break;
      }
    };
    const del = (id) => {
      if (!id) {
        ElMessage("所选数据为空，请重新选择！");
      } else {
        ElMessageBox.confirm("确定要删除该条数据吗?", "警告", {
          confirmButtonText: "删除",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            delShippingDetails({ id: id, del_type: 0 }).then((res) => {
              if (res.code == 0) {
                ElMessage.success(res.msg);
                getList();
              } else {
                ElMessage.error(res.msg);
              }
            });
          })
          .catch(() => {
            ElMessage({
              type: "info",
              message: "删除取消",
            });
          });
      }
    };
    const closeAction = () => {};
    // 新增弹窗关闭
    const closeFormDialog = (params) => {};
    return {
      closeFormDialog,
      formDialog,
      config,
      actionClick,
      currentPage,
      pageSize,
      pageTotal,
      tableLoading,
      totalData,
      getList,
      searchList,
      pageChange,
      sizeChange,
      handleSelectedRow,
      formDialogIns,
      getShippingDetails,
      ship_id,
      ship_no,
      isEdit,
      editProduct,
      saveProduct,
      del,
    };
  },
};
</script>
